/**
 * Images API
 *
 * API functions for bulk image download operations.
 * Types are derived from the generated OpenAPI contract.
 */

import { apiClient } from './client';
import type {
  BulkImageDownloadJobStartResponse,
  BulkImageDownloadJobProgress,
} from './generated/contract-types';

export type BulkImageDownloadJobStatus = BulkImageDownloadJobProgress['status'];

export const startBulkImageDownload = async (
  productIds: number[]
): Promise<BulkImageDownloadJobStartResponse> => {
  const response = await apiClient.post<BulkImageDownloadJobStartResponse>(
    '/images/bulk-download',
    {
      productIds,
    }
  );
  return response.data;
};

export const getBulkImageDownloadProgress = async (
  jobId: string
): Promise<BulkImageDownloadJobProgress> => {
  const response = await apiClient.get<BulkImageDownloadJobProgress>(
    `/images/bulk-download/${jobId}`
  );
  return response.data;
};

export const downloadBulkImageZip = async (
  jobId: string
): Promise<{ data: Blob; contentDisposition?: string }> => {
  const response = await apiClient.get<Blob>(`/images/bulk-download/${jobId}/download`, {
    responseType: 'blob',
  });
  const contentDisposition = response.headers['content-disposition'] as string | undefined;
  return { data: response.data, contentDisposition };
};
